import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { queryClient } from './lib/queries';
import { realtime } from './lib/realtime';
import { useSession } from './lib/session';
import { installAudioUnlock } from './game/audio';
import './styles.css';

installAudioUnlock();

void useSession
  .getState()
  .bootstrap()
  .finally(() => void realtime.connect());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
